import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import VrrModal from '../../../shared_components/vrr_modal';
import LabelModalHeader from './label_modal_header';
import LabelsTable from './labels_table/LabelsTable';
import VrrCircleLoader from '../../../shared_components/vrr_circle_loader';
import { prepareCustomLabelsList } from './services';
import {
  fetchBrandLabels,
  getBrandLabels,
  refreshAccountLabels
} from '../../../../redux/userProfile/userProfileActions';
import { TLabelModal } from './types';
import { TBrandLabel } from '../../../../redux/userProfile/types';
import {
  getCurrentCustomLabelsPreferences,
  getCustomLabelsPreferences
} from '../../../../redux/settings/settingAction';

const LabelModal: React.FC<TLabelModal> = ({
  id,
  brand,
  isOpen,
  onCancelAction,
  onSubmitAction
}: TLabelModal) => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const brandLabels: TBrandLabel[] | undefined = useSelector(getBrandLabels);
  const customLabels = useSelector(getCustomLabelsPreferences);
  const currentCustomLabels = useSelector(getCurrentCustomLabelsPreferences);
  const [labels, setLabels] = useState<TBrandLabel[]>([]);

  useEffect(() => {
    if (isOpen && brand) {
      dispatch(fetchBrandLabels(brand));
    }
  }, [isOpen]);

  const onCancel = () => {
    setLabels([]);
    if (onCancelAction) onCancelAction();
  };

  const onSubmit = () => {
    const newLabels = prepareCustomLabelsList(brand, labels, customLabels);
    if (onSubmitAction) onSubmitAction(newLabels ?? []);
    onCancel();
  };

  return (
    <VrrModal
      className="label-modal"
      isOpen={isOpen}
      modalHeader={
        <LabelModalHeader
          onClickRefresh={() => {
            if (brand) dispatch(refreshAccountLabels(brand));
          }}
          disableRefresh={!brandLabels}
        />
      }
      modalBody={
        <ModalBody className="label-modal-modal-body">
          <VrrCircleLoader isEnable={!brandLabels}>
            {!brandLabels?.length ? (
              t('connected_account.label_modal.no_labels')
            ) : (
              <LabelsTable
                id={id}
                labels={brandLabels}
                customLabels={currentCustomLabels}
                onChangeAction={setLabels}
              />
            )}
          </VrrCircleLoader>
        </ModalBody>
      }
      toggleModal={onCancel}
      toggleValidation={onSubmit}
      scrollable
    />
  );
};

export default LabelModal;
